export default "__VITE_ASSET__A9cFoen9__"